import { get } from 'lodash'

const gridView = {
  name: 'gridView',
  label: 'grid_view',
  icon: 'calendar_view_month',
}
const cardView = {
  name: 'cardView',
  label: 'card_view',
  icon: 'apps',
}
const detailView = {
  name: 'detailView',
  label: 'detail_view',
  icon: 'view_headline',
}

export const PROP_ROW_KEY = 'ROW_KEY'
export const VIEW_MODE_GRID = gridView.name
export const VIEW_MODE_CARD = cardView.name
export const VIEW_MODE_DETAIL = detailView.name
export const LIST_VIEW_MODES = {
  gridView,
  cardView,
  detailView,
}

export const COLLAPSED_SETTINGS = {
  hamburgerMenu: false,
  pagination: false,
  limitation: false,
  tableHeader: true,
  search: false,
  rowSelection: false,
  expandRow: false,
  isExpanded: true,
  aggregation: true,
}
export const DATE_INT_FORMAT = 'date_interval'
export const TIME_INT_FORMAT = 'time_interval'
export const DATETIME_INT_FORMAT = 'datetime_interval'
export const NUMBER_INT_FORMAT = 'number_interval'
export const INTERVAL_COLUMN_TYPES = {
  DATE_INT_FORMAT,
  TIME_INT_FORMAT,
  DATETIME_INT_FORMAT,
  NUMBER_INT_FORMAT,
}
export const DEFAULT_AGGREGATIONS = []
export const DEFAULT_AGGREGATE_COLUMN = {}
export const DEFAULT_AGGREGATE_ROW = []
export const DEFAULT_AVAILABLE_IN_DETAIL_VIEW = []
export const DEFAULT_AVAILABLE_IN_LIST = []
export const DEFAULT_BUTTONS = {}
export const DEFAULT_COLUMNS = []
export const DEFAULT_CONFIRM_OPTIONS = {
  text: 'are_you_sure',
  status: false,
  modalId: `confirm-modal-id`,
  callBack: false,
}
export const DEFAULT_CURRENT_PARAMETERS = {
  start: 0,
  length: 0,
  selectedRow: '',
  selectedRows: [],
  selectedRowsFilter: 'normal',
  hiddenSearchData: {},
  textLimit: 0,
  formId: '',
  queryId: '',
  u: '',
  controllerName: '',
  showDetails: false,
}
export const DEFAULT_DISABLED = false
export const DEFAULT_FETCHING_LIST_DATA = false
export const DEFAULT_GROUP_ACTIONS_RUNNING = false
export const DEFAULT_DYNAMIC_STYLE = {
  class: 'sticky-scroll',
}
export const DEFAULT_EXPORT_SETTINGS = {
  showExportButton: true,
  exportTypes: {
    html: true,
    csv: true,
    txt: true,
    pdf: true,
    xlsx: true,
    ods: true,
  },
}

export const DEFAULT_SQL_SELECT_EXTENDED_OPTIONS = {
  showLockColumn: false,
  showSelectionColumn: true,
  showCreateDate: false,
  showCreateUser: false,
  showDetailView: false,
  showExportButton: false,
  showResetButton: false,
  showColumnSelector: false,
  showActionButtons: false,
  showFooterButtons: false,
  showSavedFilter: false,
  showListOnStart: false,
  showCollapsedActions: false,
  showGroupActionsButton: false,
  showUniversalFilter: false,
  showPageLimiter: false,
  showPagination: true,
}

export const DEFAULT_SQL_SELECT_AVAILABLE_VIEWS = {
  gridView: true,
  cardView: false,
  detailView: false,
  defaultView: 'gridView',
}

export const DEFAULT_EDITABLE_LIST_EXTENDED_OPTIONS = {
  showPageLimiter: true,
  showPagination: true,
  showSavedFilter: true,
  showLockColumn: true,
  showSelectionColumn: true,
  showGroupActionsButton: false,
  showCreateDate: false,
  showCreateUser: false,
  showColumnSelector: true,
  showCollapsedActions: true,
  showResetButton: true,
  showDetailView: true,
  showActionButtons: true,
  summaryRowDefault: false,
  actionButtonsStyle: 'Not-Inline',
  runGroupActionsOnAllWithoutSelect: false,
  showFilters: true,
  showFooterButtons: true,
  editUrl: null,
  searchKeypress: false,
  deleteValueOnFilterUpdate: true,
  availableViews: {
    gridView: true,
    cardView: false,
    detailView: false,
    defaultView: 'gridView',
  },
  dbClickRedirect: {
    active: false,
    popup: false,
    url: '',
  },
  columns: null,
  exportOriginalType: false,
}

export const DEFAULT_EXTENDED_OPTIONS = {
  showPageLimiter: true,
  showPagination: true,
  showSavedFilter: true,
  showLockColumn: true,
  showSelectionColumn: true,
  showGroupActionsButton: false,
  showCreateDate: false,
  showCreateUser: false,
  showColumnSelector: true,
  showCollapsedActions: true,
  showResetButton: true,
  showDetailView: true,
  showActionButtons: true,
  summaryRowDefault: false,
  actionButtonsStyle: 'Not-Inline',
  runGroupActionsOnAllWithoutSelect: false,
  showFilters: true,
  showFooterButtons: true,
  editUrl: null,
  searchKeypress: false,
  deleteValueOnFilterUpdate: true,
  availableViews: {
    gridView: true,
    cardView: true,
    detailView: true,
    defaultView: 'gridView',
  },
  dbClickRedirect: {
    active: false,
    popup: false,
    url: '',
  },
  columns: null,
  exportOriginalType: false,
}

export const READ_VIEW_EXTENDED_OPTIONS = {
  showPageLimiter: false,
  showSavedFilter: false,
  showLockColumn: false,
  showSelectionColumn: false,
  showGroupActionsButton: false,
  showCreateDate: false,
  showCreateUser: false,
  showColumnSelector: false,
  showCollapsedActions: false,
  showResetButton: false,
  showDetailView: false,
  showActionButtons: false,
  summaryRowDefault: false,
  actionButtonsStyle: 'Not-Inline',
  runGroupActionsOnAllWithoutSelect: false,
  showFilters: false,
  showFooterButtons: false,
  editUrl: null,
  searchKeypress: false,
  deleteValueOnFilterUpdate: false,
  availableViews: {
    gridView: false,
    cardView: false,
    detailView: false,
    defaultView: 'gridView',
  },
  dbClickRedirect: {
    active: false,
    popup: false,
    url: '',
  },
  exportOriginalType: false,
  hideListOpener: false,
}
export const DEFAULT_HIDDEN_SEARCH = {}
export const DEFAULT_LIMITATION = 10
export const DEFAULT_ORDER = {}
export const DEFAULT_LIST_VISIBILITY_OPTIONS = {
  isExpanded: false,
  hamburgerMenu: get(window.CORE, 'basicFunction["dummy/gridview-custom-columns"].active', true),
  pagination: true,
  limitation: true,
  tableHeader: true,
  visibleUnselectedRows: true,
  search: true,
  rowSelection: true,
  expandRow: true,
  aggregation: true,
}
export const DEFAULT_PRIMARY_KEY = ''
export const DEFAULT_PAGER = {
  offset: 0,
  limit: DEFAULT_LIMITATION,
  total: 0,
}
export const DEFAULT_PROCESS_ACTIONS = []
export const DEFAULT_PROCESS_ACTIONS_BUTTONS = []
export const DEFAULT_ROW_CLASSES = {}
export const DEFAULT_ROW_DETAILS = {}
export const DEFAULT_ROW_STYLES = {}
export const DEFAULT_COLUMN_CLASSES = {}
export const DEFAULT_COLUMN_STYLES = {}
export const DEFAULT_CELL_CLASSES = []
export const DEFAULT_CELL_STYLES = []
export const DEFAULT_ROW_SELECTION_MODE = 'normal'
export const DEFAULT_SEARCH_PARAMS = {}
export const DEFAULT_SEARCH_PARAMS_COMP = {}
export const DEFAULT_SELECTED_GROUP_ACTION = null
export const DEFAULT_SELECTED_QUEUE_ACTION = null
export const DEFAULT_SELECTED_ROW = ''
export const DEFAULT_SELECTED_ROWS = []
export const DEFAULT_SELECTED_ROWS_FILTER = 'normal'
export const DEFAULT_SHOW_IN_LIST = []
export const DEFAULT_SHOW_LIST_ON_START = false
export const DEFAULT_UNIVERSAL_FILTER = {
  value: '',
  type: 'universalFilter',
  placeholder: 'universal_filter_bar',
}
export const DEFAULT_VISIBLE_COLUMNS = []
export const DEFAULT_EXPANDED_ROWS = []
export const MAX_CHARACTERS_IN_GRID_VIEW = 40
export const EXTENDED_TO_VISIBILITY_PROPS = [
  'isExpanded',
  'summaryRowDefault',
  'showActionButtons',
  'showCollapsedActions',
  'showColumnSelector',
  'showDetailView',
  'showImportButtons',
  'showFilters',
  'showFooterButtons',
  'showGroupActionsButton',
  'showQueueActionsButton',
  'showPagination',
  'showPageLimiter',
  'showResetButton',
  'showSavedFilter',
  'showSelectionColumn',
  'showUniversalFilter',
]
export const QUERY_BUILDER_COLUMN_FORMATS = {
  default: -1,
  string: 0,
  number: 1,
  thousandSep: 2,
  date: 3,
  boolean: 4,
  map: 5,
  document: 6,
  thumbnail: 7,
  datetime: 8,
}
export const DROPDOWN_BOOLEAN_OPTIONS = (translate) => [
  {
    key: 'null',
    value: `${translate('filter_simplified_unset')}`,
    html: `<span class="me-1" style="width: 35px;">null</span>
                 <span>${translate('filter_simplified_unset')}</span>`,
  },
  {
    key: '0',
    value: `${translate('filter_simplified_false')}`,
    html: `<span class="material-icons md-18 me-1" style="width: 35px;">check_box_outline_blank</span>
                 <span>${translate('filter_simplified_false')}</span>`,
  },
  {
    key: '1',
    value: `${translate('filter_simplified_true')}`,
    html: `<span class="material-icons md-18 me-1 is-checked" style="width: 35px;">check_box</span>
                 <span>${translate('filter_simplified_true')}</span>`,
  },
]
export const SELECTED_ROW_OPTIONS = {
  normal: {
    key: 'normal',
    label: 'selectedRows_all',
    icon: ['check_box_outline_blank', 'check_box'],
  },
  selected: {
    key: 'selected',
    label: 'selectedRows_selected',
    icon: ['check_box'],
  },
  inverse: {
    key: 'inverse',
    label: 'selectedRows_free',
    icon: ['check_box_outline_blank'],
  },
}

export const READ_VIEW_LIST_CONTAINER_LAYOUT = `  
  <sql-chosen-control-buttons :isReadView='isReadView' v-if='isSqlChosen' :mongoId="mongoId"/>
  <list-view-container :isReadView='isReadView'/>
  <pagination />
`

export const DEFAULT_LIST_CONTAINER_LAYOUT = `
  <progress-bar/>
  <div class='hamburger-container'>
    <div class='col-sm-12 mb5 d-flex gap-1 flex-wrap justify-content-between align-items-end'>
      <list-header-menu />

      <queue-button-group/>
      <!--Universal Filter-->
      <search-control
        class='mb-2 ms-0 ms-sm-0 flex-grow-1 flex-md-grow-0 order-4 order-md-2 w-md-100'
        :is-universal='true'/>
      <!--Page Limiter-->
      <limitation class='el-select mb-2 ms-md-auto order-3'/>
    </div>
  </div>
  <!--    Pagination    -->
  <pagination v-if='!isSqlChosen'/>
  <!--    SqlChosen Control Buttons    -->
  <sql-chosen-control-buttons v-if='isSqlChosen' :mongoId="mongoId"/>
  <!--    List View    -->
  <list-view-container/>
  <!--    Paginator    -->
  <pagination/>
  <!--    List Button Container    -->
  <list-button-container v-if='showButtonContainer'/>
`
export const DEFAULT_LAYOUT = `
  <template v-if="isReadView">
    ${READ_VIEW_LIST_CONTAINER_LAYOUT}
  </template>
  <template v-else>
    ${DEFAULT_LIST_CONTAINER_LAYOUT}
  </template>
`
export const AGGREGATABLE_COLUMN_TYPES = ['number', 'time', 'date', 'datetime-local']
export const SYSTEM_DATE_FIELDS = ['CREATE_DATE', 'STORNO_DATE', 'MOD_DATE', 'VALID_FROM', 'VALID_TO']
export const AGGREGATION_OFF = 'Off'
export const SOURCE_TYPES = {
  EDITABLE_LIST: 'editableList',
  FORM: 'form',
  MONGO: 'mongo',
  PROCESS: 'process',
  QUERY: 'query',
  RAW_SQL: 'rawSql',
  SQL_CHOSEN: 'sqlChosen',
  TASK_BOARD: 'taskBoard',
  TASK_LIST: 'taskList',
  WORKFLOW: 'workflow',
  UNKNOWN: 'unknown',
  FORM_VERSION: 'formVersion',
}

export const GETTER_PROPERTIES = {
  COLUMN: 'column',
  COLUMNS: 'columns',
  CSS_CONTENT: 'cssContent',
  EMPTY_TEMPLATE: 'emptyTemplate',
  EXPORT_COLUMNS: 'exportColumns',
  FOOTER: 'footer',
  HIDDEN_FILTER: 'hiddenSearchData.filterExp',
  HIDDEN_LOGIC: 'hiddenSearchData.logic',
  HIDDEN_SEARCH: 'hiddenSearchData',
  HIDDEN_WHERE: 'hiddenSearchData.where',
  HTML_CONTENT_VUE: 'htmlContentVue',
  ID: 'id',
  JS_CONTENT: 'jsContent',
  LIST: 'list',
  LIST_TEMPLATE: 'listTemplate',
  ORDER: 'order',
  ORDER_COLUMNS: 'orderColumns',
  PANEL_ID: 'panelId',
  QUERY_ID: 'queryId',
  QUERY: 'query',
  SHOW_DETAILS: 'showDetails',
  STYLE_OPTIONS: 'styleOptions',
  TEXT_LIMIT: 'textLimit',
  UNIVERSAL_FILTER: 'u',
  VUE_CONTENT: 'htmlContentVue',
  WRAPPER_TEMPLATE: 'wrapperTemplate',
}

export const OPERATORS = {
  AND: 'and',
  ASCENDING: 'asc',
  BETWEEN: 'between',
  BIND_ANNOTATION: ':',
  DESCENDING: 'desc',
  EQUALS: '=',
  IN: 'in',
  LIKE: 'like',
  LIKE_PLUS: 'like+',
}

export const HTML_ATTRIBUTES = {
  CLIENT_HEIGHT: 'clientHeight',
  DOCUMENT: 'document',
  DOCUMENT_ELEMENT: 'documentElement',
  SCRIPT: 'script',
  SCROLL_HEIGHT: 'scrollHeight',
  STYLE: 'style',
  TEXT_CSS: 'text/css',
  TEXT_JAVASCRIPT: 'text/javascript',
  TYPE: 'type',
}

export const BUTTON_ACTIONS = {
  SEARCH: 'search',
  CLEAR: 'clear',
}

export const DEFAULT_LAYOUT_TEMPLATES = [
  `<div><list-filter/><list/></div>`,
  `<div>{{ $i18n.t('no_filter_template_available') }}</div>`,
  `<div>{{ $i18n.t('no_list_item_template_available') }}</div>`,
  `<div>{{ $i18n.t('no_empty_template_available') }}</div>`,
]

export const LAYOUT_NAMES = ['wrapperLayout', 'filterLayout', 'listItemLayout', 'emptyLayout']

export const FILTER_FORMATS = {
  BASE_INPUT: 'base-input',
  DROPDOWN: 'dropdownlist',
  DATE_INT_FORMAT: 'date_interval',
  MULTI_COMPLETE: 'multicomplete',
  NUMBER_INT_FORMAT: 'number_interval',
  TEXT: 'text',
  UNIVERSAL: 'universal-filter',
}

export const FILTER_TEMPLATES = {
  CLEAR_BUTTON: 'clear-button',
  MULTI_COMPLETE: 'multicomplete',
  SEARCH_BUTTON: 'search-button',
  UNIVERSAL: 'u',
}

export const TEMPLATED_LIST_FILTERS = {
  [FILTER_FORMATS.BASE_INPUT]: 'filter-text',
  [FILTER_FORMATS.DATE_INT_FORMAT]: 'filter-date-time-control',
  [FILTER_FORMATS.DROPDOWN]: 'filter-select',
  [FILTER_FORMATS.NUMBER_INT_FORMAT]: 'filter-number',
  [FILTER_FORMATS.TEXT]: 'filter-text',
}

export const COMPONENT_TAG_RE = {
  CLEAR_BUTTON: /<list-filter-button\s*.*\sbtn-action="clear"/gim, // @regex clearbutton-ra parameterezett tag-re matchel
  FILTER_CONTROL: /(?<=list-filter-control\s+name=["'])(\w+)/gim, // @regex filter-control tag-re matchel, kiveszi a name-et
  SELECTION_WITH_LABEL: /<selection\s+label=["']([\w_-]+).*\/>/gim, // @regex labeles selection tag-re matchel
  SELECTION: /<selection(?:\s+[^>]*)?\s*\/?>/gim, // @regex selection tag-re matchel
  PAGINATION: /<pagination(?:\s+[^>]*)?\s*\/?>/gim, // @regex pagination tag-re matchel
  PROCESS_BUTTON: /<process-button-list.*\/>/gim, // @regex process-button-list tag-re matchel
  HAMBURGER: /<hamburger(?:\s+[^>]*)?\s*\/?>/gim, // @regex hamburger tag-re matchel
  // deprecate vagy future feature
  LIST_EXPORT: /<list-export(?:\s+[^>]*)?\s*\/?>/gim, // @regex list-export tag-re matchel
}

export const SEARCH_TRIGGERS = {
  CLEAR_BUTTON: 'clear-button',
  LOCAL_STORE: 'local-store',
  SAVED_FILTER: 'saved-filter',
  SEARCH_BUTTON: 'search-button',
  URL_PARAMS: 'url-params',
}

export const ROW_STYLE_REGEXP = new RegExp(`model\\["([^"]+)"\\]\\s*(<=|>=|==|!=|<|>)\\s*[^&|]+`, 'g') // @regex model[""] =/!= <expression> formátumra matchel
export const ROW_STYLE_MODEL_REGEXP = /model\[(["'])([\p{L}\p{N} _-]*)\1\]/gu // @regex model[""] formátumra matchel
export const ROW_STYLE_ROW = 'ROW'
export const ROW_STYLE_COLUMN = 'COLUMN'
export const ROW_STYLE_CELL = 'CELL'

export const LIST_HEADER_SMALL_SCREEN = 994
